import React from 'react';
import { Search } from 'lucide-react';

const SearchBar = ({ value, onChange, onSubmit, placeholder = 'Search...', className = '' }) => {
  return (
    <form onSubmit={(e) => { e.preventDefault(); onSubmit && onSubmit(); }} className={`relative w-full ${className}`}>
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Search className="h-4 w-4 text-gray-500" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        placeholder={placeholder}
        className="form-input pl-10 text-sm w-full"
      />
    </form>
  );
};

export default SearchBar;
